import * as React from 'react'

import { classList } from 'react-classlist-helper'

export interface MapMarkerProps {
  isSelected?: boolean
  title?: string
  onClick?: () => void
}

const MapMarker: React.FC<MapMarkerProps> = ({
  isSelected,
  title,
  onClick,
}) => (
  <div
    className={classList({
      'tw:size-5 tw:rounded-full tw:bg-chart-2 tw:border-[3px] tw:border-solid tw:border-white tw:cursor-pointer tw:shadow-[0_0_0_3px_var(--chart-2),0_4px_12px_rgba(0,0,0,0.35)]': true,
      'tw:bg-primary tw:shadow-[0_0_0_3px_var(--primary),0_4px_12px_rgba(0,0,0,0.35)] tw:scale-130':
        !!isSelected,
    })}
    title={title}
    onClick={onClick}
  />
)

export default MapMarker
